<div class="page-container">
    <h2 i18n>Assistance Packages</h2>
    <mat-card class="card designs-card">
        <mat-card-content>
            <p i18n  class="mat-card-header">Ancytree´s Assistance Packages: Choose the Perfect Package for Your Needs!</p>
            <div class="content">
                <div class="text-container">
                    <div class="description-container" i18n>
                        <span class="introduction">
                            Explore our exciting additional services to make your family tree even more unique and personal. Our three assistance packages offer different levels of guidance and design possibilities:
                        </span> 
                    </div>
                </div>
                <div class="selection-container">
                    <h2 i18n>Select your assistance package</h2>
                    <div class="options-container">
                        <div class="option">
                            <div class="top-container">
                                <div class="name-container">
                                    <h2 i18n >Discover Ancytree</h2>
                                </div>
                                <div class="img-container">
                                    <img src="./assets/image/assistance-packages/discover.png" alt="">
                                </div>
                            </div>
                            <div class="bottom-container">
                                <div class="option-description-container">
                                    <p i18n class="title">Explore Ancytree in our shared digital session</p>
                                    <p i18n>
                                        Book your spot for a shared digital session where you'll get an overview of Ancytree, learn to create your profile, and upload your GEDCOM file. Opportunity to ask questions after the session. 
                                    </p>
                                    <p i18n>
                                        Limited spots – book now!
                                    </p>
                                </div>
                                <div class="select-container">
                                    <p i18n >Free</p>
                                    <button i18n  *ngIf="selectedAP.value.attributeId != null" (click)="changeId(null)">Select</button>
                                    <button i18n  class="selected-button" *ngIf="selectedAP.value.attributeId == null" >Selected</button>
                                </div>
                            </div>
                        </div>
                        <div class="option">
                            <div class="top-container">
                                <div class="name-container">
                                    <h2 i18n >Quick Start</h2>
                                </div>
                                <div class="img-container">
                                    <img src="./assets/image/assistance-packages/quickstart.png" alt="">
                                </div>
                            </div>
                            <div class="bottom-container">
                                <div class="option-description-container">
                                    <p i18n class="title">Kickstart your family tree with our individual quick start package</p>
                                    <p i18n>
                                        An individual session for a quick start where you'll receive valuable tips and tricks. 
                                        We'll also present 1-2 design proposals to get you started.
                                    </p>
                                </div>
                                <div class="select-container">
                                    <p><app-currency-converter [data]="{price:25, country: null}"></app-currency-converter></p>
                                    <button i18n  *ngIf="selectedAP.value.attributeId != '13'" (click)="changeId('13')">Select</button>
                                    <button i18n  class="selected-button" *ngIf="selectedAP.value.attributeId == '13'" >Selected</button>
                                </div>
                            </div>
                        </div>
                        <div [ngClass]="{'biggeroption': readMore, 'option' : true }">
                            <div class="top-container">
                                <div class="name-container">
                                    <h2 i18n >Design Help</h2>
                                </div>
                                <div class="img-container">
                                    <img src="./assets/image/assistance-packages/designhelp.png" alt="">
                                </div>
                            </div>
                            <div class="bottom-container">
                                <div class="option-description-container">
                                    <p i18n class="title">Create a unique family tree with personalized design help and expert guidance</p>
                                    <p i18n>
                                        Get personal guidance and special tips to create your unique family tree. 
                                        We'll present 2-3 design proposals tailored to your preferences and offer assistance in creating your own high-resolution background.
                                    </p>
                                    
                                </div>
                                <div>
                                    <div class="disclamer">
                                        <p i18n [ngClass]="{'limitTextHeight': !readMore}">
                                            Important message about image quality: If you have a specific image you want to use as a background for your family tree, please note that choosing to convert a low-resolution image to high-resolution format carries the risk of maintaining the original image's quality, resulting in a blurry and poor-quality picture.
                                            We therefore recommend using a high-quality image for the best results.
                                        </p>
                                        <div class="disclamer-title-container">
                                            <p i18n (click)="readMore = !readMore" *ngIf="!readMore" class="disclamer-read">
                                                Read More
                                            </p>
                                            <p i18n (click)="readMore = !readMore" *ngIf="readMore" class="disclamer-read">
                                                Read Less
                                            </p>
                                        </div>
                                    </div>
                                    <div class="select-container">
                                        <p><app-currency-converter [data]="{price:50, country: null}"></app-currency-converter></p>
                                        <button i18n  *ngIf="selectedAP.value.attributeId != '14'" (click)="changeId('14')">Select</button>
                                        <button i18n  class="selected-button" *ngIf="selectedAP.value.attributeId == '14'" >Selected</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   </div>
                <div class="button-container">
                    <button (click)="selectPackage()">
                        <span *ngIf="selectedAP.value.attributeId != null" i18n>Buy your package</span>
                        <span *ngIf="selectedAP.value.attributeId == null" i18n>Reserve your spot</span>
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
